<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'hidden-block',
  methods: {
    toggle() {
      this.$el.children[1].classList.toggle('hidden');
    }
  },
  mounted() {
    this.$el.classList.add('scoped');
  },
});
</script>

<template>
  <div>
    <div class="hidden-block_header capitalize text-right">
      <span @click="toggle">↓</span>
    </div>
    <div class="hidden-block_content hidden">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
.scoped { .hidden-block_header { & > span { @apply cursor-pointer opacity-10 } } }
</style>